import { useCustomTranslation } from '../../../../../../hooks';
import { useGraphneAPI, ApiSimulationParameterValue } from '@nexelem/graphne-api';
import { useMutation } from '@tanstack/react-query';
import { useCustomToast } from '@nexelem/snackbar';
import { useSimulationId } from '../../hooks';
import { extractResponseErrorMessage } from '@nexelem/utils';
import { generatePath, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../../../../routes/config';

export const useGanttSimulationOptimize = () => {
  const api = useGraphneAPI();
  const { tWrapper } = useCustomTranslation('products.simulationPlan');
  const displayToast = useCustomToast();
  const { id: simulationId } = useSimulationId();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (parameterValues: ApiSimulationParameterValue[]) =>
      api.postGraphneSimulationSimulationidOptimize({
        simulationId: simulationId.toString(),
        simulationCreateOptimizeView: {
          parameterValues,
        },
      }),
    onSuccess: (id) => {
      navigate(generatePath(ROUTES.plan.simulationPath, { id: id.toString() }));
    },
    onError: async (err: Error) => {
      const message = await extractResponseErrorMessage(err);
      displayToast({
        toastType: 'error',
        message: `${tWrapper('cannotCreateSimulation')} ${message}`,
      });
    },
  });
};
